export default [
  {
    key: "increasement",
    sortable: false,
    sortField: "createdAt",
    label: "label.no",
  },
  {
    key: "question",
    sortable: false,
    label: "field.question",
    class: "w-half break-spaces",
  },
  {
    key: "answer",
    sortable: false,
    label: "field.answer",
    class: "w-half break-spaces",
  },
  {
    key: "count",
    sortable: false,
    label: "field.count",
  },
  {
    key: "createdAt",
    sortable: false,
    label: "field.createDate",
  },
  {
    key: "actions",
    label: "general.action",
  },
];
